import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DescriptiveItemComponent } from '@shared/descriptive-item/descriptive-item.component';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

@Component({
    selector: 'app-custom-cell-company',
    templateUrl: './custom-cell-company.component.html',
    styleUrl: './custom-cell-company.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DescriptiveItemComponent]
})
export class CustomCellCompanyComponent implements ICellRendererAngularComp {
    companyName = '';
    companyId?: boolean;
    currentCompanyId?: boolean;

    agInit(params: ICellRendererParams<any, any, any>): void {
        const data = params.data;
        this.companyId = data?.companyId;
        this.currentCompanyId = data?.currentCompanyId;
        this.companyName = params.value;
    }

    refresh(): boolean {
        return false;
    }
}
